<template>
  <div>

    <ed-modal :modal="showModal" :title="'EXAMES'+(funcionario ? ' - '+funcionario.nome : '')+(formData.consulta ? ' - CONSULTA '+formData.consulta.id_con : '')" width="60%">
    
    <div slot="modal-content">
      <table class="table historico-consulta" v-if="formData.consulta">
        <tr>
          <th style="text-align:left;font-size:7pt;background:#eeeeee">Exame</th>
          <th width="100" style="text-align:left;font-size:7pt;background:#eeeeee">Data</th>
          <th width="100" style="text-align:left;font-size:7pt;background:#eeeeee">Valor</th>
        </tr>
        <tr v-for="exame in formData.consulta.exames" :key="exame.id">
          <td style="font-size:8pt">
            {{exame.exame.nome}}
            <span v-if="exame.consulta_rea" style="font-size:9pt;">
              <br>
              Exame reaproveitado na consulta <label style="color:red">{{exame.consulta_rea.id_con}}</label> em {{toDate(exame.consulta_rea.dt_cad,true)}}
            </span>
          </td>
          <td style="font-size:8pt">
            {{(exame.consulta_rea ? '---' : toDate(exame.dt_cad,true))}}
          </td>
          <td style="font-size:8pt">{{(exame.consulta_rea ? '---' : exame.valor)}}</td>
        </tr>
      </table>
    </div>
  </ed-modal>
  
  <ed-alert
    class="mb-3"
    type="warning"
    description="Exibindo o histórico de consultas dos últimos 5 anos"
    title="Atenção"
  />

  <ed-table
    :tableData="tableData"
    :tableHead="tableHead"
    :pagination="pagination"
    :response="response"
    :loadingTable="loadingTable"
    disableCheckAll
    disableInputSearch
    />

  </div>
</template>

<script>

import Rest from 'common/rest'
import EdTable from 'common/table'
import EdModal from 'common/modal'
import EdAlert from 'common/alert'

export default {
    name: 'EmpresaCadastro',
    components:{EdModal,EdAlert,EdTable},
    mixins:[Rest],
    props:{
    funcionario:{
      type: Object,
      default: null
    },
    id_funcao:{
      type: Number,
      default: null
    },
  },
  watch:{
    funcionario(){
      this.getHistorico()
    },
    id_funcao(){
      this.getHistorico()
    },
  },

  data () {
    return{
      formData:{
        historico:null,
        consulta:null,
      },
      pagination:{},
      response:{},
      tableData:[],
      tableHead:[
        {
          key: 'consulta',
          sortable: true,
          label: 'Consulta',
          width:'50px',
        },
        {
          key: 'data',
          sortable: true,
          label: 'Data',
          width:'100px',
        },
        {
          key: 'tipo_aso',
          sortable: true,
          label: 'Tipo',
          width:'150px',
        },
        {
          key: 'funcao',
          sortable: true,
          label: 'Função',
        },
      ],
      showModal:false,
      loadingTable:false,
    }
  },
  created(){
  },
  mounted(){
    this.getHistorico();
  },

  methods: {

    onShowExame(data){
      this.showModal = !this.showModal;
      this.formData.consulta = data;
    },

    getHistorico(_search){

      if(!this.funcionario || !this.funcionario.id)return;

      this.loadingTable = true;
      this.formData.historico = null;
      this.response = {};

      var 
      ontem = this.convertDate(this.addDate(-5,null,'y')),
      amanha = this.convertDate(this.addDate(30,null)),
      filter = {
        //id_funcao: this.id_funcao,
        id_funcionario: this.funcionario.id,
        created_at: [ontem,amanha]
      };

      this.get('consulta',{filter:filter}).then((result) =>{
        result = result[0];

        this.response = result;
        this.loadingTable = false;

        var data = [], tableData = [], pagination = {};

        if(result.status == 200){
            
          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              consulta: data[i].id_con,
              funcao: (data[i].funcao ? data[i].funcao.nome : null),
              tipo_aso: (data[i].tipo_aso ? data[i].tipo_aso.descricao : null),
              data: this.toDate(data[i].dt_cad,true),
              _data: data[i],
              buttons : [
                {
                  color: 'primary',
                  icon : 'fa fa-search',
                  title: 'Ver Exames',
                  click : this.onShowExame

                },
              ]
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        this.tableData = tableData;
        this.pagination = pagination;
      });
    },

  }
}
</script>


// WEBPACK FOOTER //
// historico.vue?441c3d2c